import React, { useState } from 'react';
import GameKeysList from './components/GameKeysList';
import ActionBar from '../layout/ActionBar';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import GameKeyTableViewSwitcher from './components/GameKeyTableViewSwitcher';
import GameKeysListByWorkflow from './components/GameKeysListByWorkflow';
import { usePageTitle } from '../../util/pageTitle';

function GameKeys() {
  usePageTitle(['Game keys', 'Keys']);
  const [groupBy, setGroupBy] = useLocalStorage<'total' | 'workflow'>('gameKeys-groupBy', 'total');
  const { t } = useTranslation();
  const [reload] = useState(undefined);
  const [breadcrumb, setBreadcrumb] = useState<{ label: string; link: string }[]>([
    { label: t('Game keys'), link: '/keys/game' },
  ]);

  return (
    <>
      <ActionBar breadcrumb={breadcrumb} />
      {groupBy === 'total' ? (
        <GameKeysList
          reload={reload}
          setBreadcrumb={setBreadcrumb}
          tableViewSwitcher={
            <GameKeyTableViewSwitcher
              groupBy={groupBy}
              setGroupBy={setGroupBy}
            />
          }
        />
      ) : (
        <GameKeysListByWorkflow
          reload={reload}
          setBreadcrumb={setBreadcrumb}
          tableViewSwitcher={
            <GameKeyTableViewSwitcher
              groupBy={groupBy}
              setGroupBy={setGroupBy}
            />
          }
        />
      )}
    </>
  );
}

export default GameKeys;
